module.exports = __webpack_public_path__ + "static/img/wancheng.02a234a5.png";